// extracted by mini-css-extract-plugin
export var completionBody = "_jq-2";
export var completionCard = "_jq-0";
export var completionFooter = "_jq-3";
export var completionTitle = "_jq-1";